<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container clearfix">
      <div class="b-container clearfix">
        <div class="b-center-main clearfix">
          <!-- 产品列表 -->
          <div class="b-productList clearfix">
            <ul>
              <li v-for="item in productList"
                  :key="item">
                <div class="b-item-link">
                  <a :href="item.linkUrl">
                    <div class="b-img">
                      <img :src="item.img"
                           alt="img">
                    </div>
                    <div class="b-item-name">{{ item.name }}</div>
                  </a>
                  <div class="b-decription">{{item.description}}</div>
                </div>
              </li>
            </ul>
          </div>
          <el-pagination class="clearfix" background
                         layout="prev, pager, next"
                         :total="1000">
          </el-pagination>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Footer from "@/components/footer/";
import Contact from "@/components/contact/";
export default {
  data () {
    return {
      productList: [],
    };
  },
  mounted () {
    // 产品列表
    this.productList = [
    ];
  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
/* banner背景 */
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }

/* 产品列表 */
.b-productList ul {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
  li {
    width: 20%;
    float:left;
    margin: 0 0 15px 0;
    .b-item-link {
      margin: 0 8px;
/*      border: 1px solid #ddd;*/
      display: block;
      padding: 10px;
      height: 260px;
      overflow: hidden;
    }
    .b-img {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
    }

    .b-item-name {
      text-align: center;
      color: rgb(102, 102, 102);
      font-size: 14px;
      /* font-weight: bold; */
      height: 25px;
      line-height: 25px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
      margin: 10px 0;
      &:hover {
        color: #2ba8e2;
        text-decoration: none;
        cursor: pointer;
      }
    }
    .b-decription {
      text-align: left;
      color: #666;
      font-size: 12px;
      line-height: 20px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
      overflow: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product/index.vue